import { create } from 'zustand';
import { getPromiseWithResolvers } from '@inter-ikea-storageone/shared/utils/getPromiseWithResolvers';

interface InitializationState {
  isCoreReady: boolean;
  isAnalyticsReady: boolean;
  setCoreReady: (isReady: boolean) => void;
  setAnalyticsReady: (isReady: boolean) => void;
}

export const useInitializationStore = create<InitializationState>(set => ({
  isCoreReady: false,
  isAnalyticsReady: false,
  setCoreReady: (isReady: boolean) => set({ isCoreReady: isReady }),
  setAnalyticsReady: (isReady: boolean) => set({ isAnalyticsReady: isReady })
}));

// Stable selector for checking if everything is ready
const selectIsReady = (state: InitializationState) => state.isCoreReady && state.isAnalyticsReady;

export const useIsReady = () => useInitializationStore(selectIsReady);

/**
 * Resolves once the startup scene restore has settled. Core being initialized only
 * means the scene exists - not that its content has been restored.
 */
const initialSceneLoad = getPromiseWithResolvers<void>();
export const initialSceneLoadPromise = initialSceneLoad.promise;
export const resolveInitialSceneLoad = initialSceneLoad.resolve;
